export default __webpack_public_path__ + "static/char-s-56-zh-Hans-cdc99c6b814ca0f6675a8fd04f861102.webp";